import request from "./request";

const Etapa = {
  obter: id => request.get(`/orcamentos/etapa/${id}`),
  cadastrar: etapa => request.post("/orcamentos/etapa", etapa),
  alterar: etapa => request.put("/orcamentos/etapa", etapa),
  excluir: id => request.del("/orcamentos/etapa", { params: { id } })
};

export default Etapa;



// WEBPACK FOOTER //
// ./src/services/etapa.js